import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { trackButtonClick } from '../utils/pixel';
import { ShieldCheck, Lock, Star, Users } from 'lucide-react';
export function HeroSection() {
  const handleCTAClick = () => {
    trackButtonClick('Hero CTA - Quiero el MegaKit ahora');
  };
  return <section className="relative pt-20 pb-24 md:pt-28 md:pb-32 overflow-hidden bg-sage" data-id="element-193">
      <div className="container mx-auto px-4 relative z-10" data-id="element-194">
        <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-195">
          <SectionWrapper data-id="element-196">
            <div className="inline-block mb-6 px-5 py-2 rounded-full bg-white/20 backdrop-blur-sm border border-white/30" data-id="element-197">
              <span className="text-white font-poppins text-sm font-semibold tracking-wide uppercase" data-id="element-198">
                Para mamás con hijos de 2 a 5 años
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-white mb-6 leading-tight max-w-4xl mx-auto" data-id="element-199">
              ¿El berrinche te ganó otra vez y terminaste gritando?
            </h1>

            <p className="text-lg md:text-xl text-cream font-poppins mb-10 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-200">
              No es falta de amor. Es falta de un sistema. El MegaKit Plan de
              Calma te da protocolos, guiones exactos y rutinas para saber qué
              hacer y qué decir la próxima vez que todo explota.
            </p>

            <div className="mb-12 p-5 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 inline-block text-left shadow-lg" data-id="element-201">
              <p className="text-white font-poppins text-sm md:text-base flex items-center gap-2 font-medium" data-id="element-202">
                📚 6 ebooks PDF + 9 bonos descargables — Basado en neurociencia
                · Para niños de 2 a 5 años · Acceso inmediato en 5 minutos
              </p>
            </div>
          </SectionWrapper>

          <SectionWrapper delay={0.2} data-id="element-203">
            <div className="w-full max-w-4xl mx-auto mb-12 relative" data-id="element-204">
              <div className="absolute inset-0 bg-white/20 blur-[100px] rounded-full -z-10" data-id="element-205"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kSN8wy6AmABMGpBn8pFo1L/mockup_rabietas_2B_limites_con_amor.png" alt="Plan de Calma MegaKit Mockup" className="w-full h-auto drop-shadow-2xl rounded-2xl" data-id="element-206" />
            </div>
          </SectionWrapper>

          <SectionWrapper delay={0.4} data-id="element-207">
            <div className="flex flex-col items-center gap-6 w-full" data-id="element-208">
              <a href="#pricing" onClick={handleCTAClick} className="w-full md:w-auto px-10 py-5 min-h-[54px] bg-dark-green hover:bg-[#23472a] text-white font-poppins font-bold text-lg md:text-xl rounded-xl transition-all duration-300 shadow-[0_8px_20px_rgba(45,90,53,0.3)] hover:shadow-[0_12px_25px_rgba(45,90,53,0.4)] transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-209">
                → Quiero el MegaKit ahora
              </a>

              <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-white/90 font-poppins font-medium" data-id="element-210">
                <span className="flex items-center gap-1.5" data-id="element-211">
                  <Star size={16} className="text-gold" fill="currentColor" data-id="element-212" />{' '}
                  4.9/5
                </span>
                <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/40" data-id="element-213"></span>
                <span className="flex items-center gap-1.5" data-id="element-214">
                  <Users size={16} data-id="element-215" /> +500 familias
                </span>
                <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/40" data-id="element-216"></span>
                <span className="flex items-center gap-1.5" data-id="element-217">
                  <ShieldCheck size={16} data-id="element-218" /> Garantía 7 días sin preguntas
                </span>
                <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/40" data-id="element-219"></span>
                <span className="flex items-center gap-1.5" data-id="element-220">
                  <Lock size={16} data-id="element-221" /> Pago seguro por MercadoPago
                </span>
              </div>
            </div>
          </SectionWrapper>
        </div>
      </div>
    </section>;
}